export const CATEGORIES = [
  {
    id: 'anatomy',
    name: 'Ocular Anatomy & Physiology',
    icon: '👁',
    description: 'Structure and function of the eye and visual system.',
  },
  {
    id: 'lenses',
    name: 'Ophthalmic Lenses',
    icon: '🔍',
    description: 'Lens types, materials, designs, and optical properties.',
  },
  {
    id: 'frames',
    name: 'Frames & Materials',
    icon: '🕶',
    description: 'Frame styles, materials, measurements, and standards.',
  },
  {
    id: 'rx',
    name: 'Prescription (Rx) Interpretation',
    icon: '📋',
    description: 'Reading and interpreting ophthalmic prescriptions.',
  },
  {
    id: 'prism',
    name: 'Prism',
    icon: '🔺',
    description: 'Prism types, effects, calculations, and applications.',
  },
  {
    id: 'measurements',
    name: 'Patient Measurements & Fittings',
    icon: '📏',
    description: 'PD, seg heights, vertex distance, frame fitting, and adjustments.',
  },
  {
    id: 'ansi',
    name: 'ANSI Standards',
    icon: '📐',
    description: 'ANSI Z80.1 tolerances and quality standards for ophthalmic lenses.',
  },
  {
    id: 'definitions',
    name: 'Optical Terminology & Definitions',
    icon: '📖',
    description: 'Key terms, definitions, and concepts in opticianry.',
  },
];
